<template>
  <div
    v-block-loading:initFetch.page="pageLoading"
    class="m-home"
    :class="{
      'no-banner': !bannerList || bannerList.length === 0
    }"
  >
    <!-- for seo -->
    <h1 style="display: none">Bet online - Sports Betting, Live Betting, Virtual Games &amp; Casino | MSport</h1>

    <BannerList
      v-if="bannerList && bannerList.length"
      :banner-list="bannerList"
      source="Home"
    />

    <!-- 二级导航 -->
    <SecondNavs
      v-if="secondNavConfig.displays.ads.length"
      :config="secondNavConfig"
    />

    <template v-if="pageLoading === false">
      <!-- casino games cards -->
      <CasinoGames v-if="gameCards.length" />

      <!-- featured matches -->
      <Featured v-if="!!validFeaturedMatches" />

      <!-- 可能没有 live / hot 比赛 -->
      <LiveContainer class="section-round" />

      <SportsContainer class="section-round" />

      <LayoutFooter
        autocheck
        class="tw-rounded-[20px]"
      />
    </template>

    <!-- HomeBottomBox ad -->
    <BubbleBall
      v-if="bubbleAd || popupAd"
      :bubble="bubbleAd"
      :popup-ad="popupAd"
    />

    <!-- product down dialog -->
    <VDialogBox
      v-model="productDownVisible"
      class="dialog-product-down"
      close-on-click-modal
      @close="onCloseProductdown"
    >
      <ProductDown
        v-if="productDownVisible"
        :poster="productDownPoster"
      />
    </VDialogBox>
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { pick } from 'lodash-es'
import { onMounted, ref, watch } from '@vue/composition-api'
import { useRealSportsStore } from '@ms/stores/realsports.js'
import VDialogBox from 'fe-vui/dialogBox'
import userPush from 'wap/components/PushPopup'
import { getAdInfo, getLocalAdReqBody } from 'wap/common/api'
import BannerList from 'wap/components/BannerList'
import SecondNavs from './pagelet/SecondNavs'
import Featured from './pagelet/Featured'
import LiveContainer from './pagelet/LiveContainer'
import SportsContainer from './pagelet/SportsContainer'
import BubbleBall from './pagelet/BubbleBall'
import LayoutFooter from 'wap/components/Footer'
import modalHelper from '@ms/utils/scroll-fixed'
import eventBus from '@ms/utils/event-bus'
import productDownPoster from 'wap/common/images/product-down.png'
import Vue from 'vue'
import Skeleton from 'wap/components/Skeleton'
import { useAuthStore } from '@ms/stores/auth'
import useBffHome from 'wap/stores/home/useBffHome.js'
import useHomeStore from 'wap/stores/home'
import { useGameCardsStore } from '@ms/stores/gameCards'

Vue.component(Skeleton.name, Skeleton)

export default {
  name: 'PageHome',
  components: {
    VDialogBox,
    BannerList,
    SecondNavs,
    CasinoGames: () => import(/* webpackChunkName: 'casinoGameCard' */ './pagelet/CasinoGames.vue'),
    Featured,
    LiveContainer,
    SportsContainer,
    BubbleBall,
    LayoutFooter,
    ProductDown: () => import(/* webpackChunkName: 'productdown' */ '@ms/components/ProductDown.vue')
  },
  setup() {
    const auth = useAuthStore()
    const { loginStatus } = storeToRefs(auth)
    const homeStore = useHomeStore()
    const { secondNavConfig, bannerList, bubbleAd, popupAd, featuredMatches, validFeaturedMatches } = storeToRefs(homeStore)
    const { getHomeConfig } = homeStore

    const game = useGameCardsStore()
    const { gameCards, getGamesCards } = storeToRefs(game)

    // page loading, true, false, -1(请求失败)
    const pageLoading = ref(true)
    const productDownVisible = ref(false)
    const { productDown } = storeToRefs(useRealSportsStore())

    const onCloseProductdown = () => {
      modalHelper.beforeClose()
      productDownVisible.value = false
    }

    watch(productDown, (val) => {
      if (val) {
        productDownVisible.value = true
        modalHelper.afterOpen()
      }
      eventBus.$emit('product-down', val)
    })

    onMounted(() => {
      eventBus.$emit('product-down', productDownVisible.value)
    })

    return {
      loginStatus,
      productDownPoster,
      productDownVisible,
      onCloseProductdown,

      secondNavConfig,
      bannerList,
      bubbleAd,
      popupAd,
      getHomeConfig,
      gameCards,

      featuredMatches,
      validFeaturedMatches,
      getGamesCards,
      pageLoading
    }
  },
  watch: {
    loginStatus(val) {
      if (val) {
        // 登录后重新获取广告配置
        this.getHomeConfig()
        this.getPopupBanner()
      }
    }
  },
  created() {
    this.initFetch()
    this.getPopupBanner()
  },
  activated() {
    !this.pageLoading && useBffHome()
    !!this.featuredMatches &&
      useHomeStore()
        .getFeaturedMatches()
        .then(() => {
          eventBus.$emit('bubbleBall_move')
        })
  },
  beforeCreate() {
    modalHelper.beforeClose()
  },
  methods: {
    async initFetch() {
      try {
        this.pageLoading = true
        await Promise.all([this.getHomeConfig(), useBffHome()])
        this.pageLoading = false
      } catch (error) {
        this.pageLoading = -1
        console.error(error)
      }
    },
    // 由于弹窗广告需要一些请求参数，故不和其他广告配置一起请求
    getPopupBanner() {
      // 是否请求弹窗广告 popupad, 如果 url 有参数 friendly === 'm', 则不请求
      const { friendly } = this.$route.query
      const adIds = ['PromoCalendar']
      let d = ''
      if (friendly !== 'm') {
        const { body } = getLocalAdReqBody('POPUP_AD')
        d = body
        adIds.push('PopupAd')
      }
      // 获取弹窗广告
      getAdInfo(adIds, d).then((data) => {
        data &&
          data.forEach((x) => {
            const adList = x.ads
            switch (x.spotId) {
              case 'PopupAd':
                if (adList.length) {
                  const { image, href, text, name } = adList[0]
                  if (userPush.getPopupAd()) this.popupAd = { image, href, text, name }
                }
                break

              case 'PromoCalendar': // 之前为 HomeBottomBox
                if (adList && adList[0]) {
                  this.bubbleAd = pick(adList[0], ['href', 'image', 'text', 'flagText'])
                }
                break
              default:
              // no default
            }
          })
      })
    }
  }
}
</script>

<style lang="less">
.dialog-product-down {
  .dialog,
  .dialog--mask {
    z-index: 10999;
  }
}

.m-home {
  background: @dark;
  color: @white;

  .section-round {
    box-shadow: 0 0 10px rgba(0,0,0,7%);
  }

  .m-tournament + .m-tournament {
    margin-top: -1px;
  }

  .m-sub-navs {
    min-width: calc(100% - 36px);
    padding: 13 / @rem 0;

    .m-sub-nav-item {
      height: 24 / @rem;
      padding: 0 10 / @rem;
      border-radius: 12 / @rem;
      margin-right: 10 / @rem;
      background: #333;
      color: #666;
      line-height: 24 / @rem;

      &.active {
        background: @primary;
        color: #1b1b1b;
      }

      &:first-child {
        margin-left: 15 / @rem;
      }

      &:last-child {
        margin-right: 15 / @rem;
      }
    }
  }

  &.no-banner {
    .m-top-navs {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        right: 15 / @rem;
        left: 15 / @rem;
        height: 1px;
        background: #1b1b1b;
        content: '';
      }
    }
  }
}

[data-mode="light"] .m-home {
  background: #f8f8f8;
}
</style>
